function StatItem({ value, label, divider }) {
  return (
    <div className={`flex items-center ${divider ? "ml-12 pl-12 border-l border-border-light dark:border-border-dark" : ""}`}>
      <div>
        <p className="font-serif italic text-3xl text-text-primary-light dark:text-text-primary-dark leading-none mb-1">
          {value}
        </p>
        <p className="font-sans text-2xs tracking-[0.25em] text-text-muted-light dark:text-text-muted-dark uppercase">
          {label}
        </p>
      </div>
    </div>
  );
}

export default StatItem;
